(() => {
  function initProduct(section) {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    const select = section.querySelector('[data-variant-select]');
    const plan = section.querySelector('[data-selling-plan]');
    const price = section.querySelector('[data-product-price]');
    const button = section.querySelector('[data-product-add]');
    const quantity = section.querySelector('[data-product-quantity]');
    const image = section.querySelector('[data-main-image]');
    if (!select) return;
    const update = (changeURL = false) => {
      const option = select.selectedOptions[0];
      if (!option) return;
      const id = option.value;
      const planId = plan?.value;
      const template = planId
        ? section.querySelector(`[data-plan-price="${id}-${planId}"]`)
        : section.querySelector(`[data-price-for="${id}"]`);
      const allowed = option.dataset.available === 'true' && (!planId || !!template);
      button.disabled = !allowed;
      button.textContent = allowed ? 'In den Warenkorb' : 'Nicht verfügbar';
      const regularPrice = section.querySelector(`[data-price-for="${id}"]`);
      price.replaceChildren((template || regularPrice).content.cloneNode(true));
      const minimum = Number(option.dataset.min) || 1;
      const step = Number(option.dataset.step) || 1;
      quantity.min = minimum;
      quantity.step = step;
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      const old = Number(quantity.value) || minimum;
      let value = minimum + Math.max(0, Math.ceil((old - minimum) / step)) * step;
      if (quantity.max) value = Math.min(value, Number(quantity.max));
      quantity.value = value;
      if (image && option.dataset.image) { image.src = option.dataset.image; image.alt = option.dataset.alt || ''; }
      if (changeURL) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', id);
        if (planId) url.searchParams.set('selling_plan', planId); else url.searchParams.delete('selling_plan');
        window.history.replaceState({}, '', url);
      }
    };
    select.addEventListener('change', () => update(true));
    plan?.addEventListener('change', () => update(true));
    section.querySelectorAll('[data-thumbnail]').forEach(link => {
      link.addEventListener('click', event => {
        if (!image || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        event.preventDefault(); image.src = link.dataset.src; image.alt = link.dataset.alt;
      });
    });
    update();
  }
  const init = scope => scope.querySelectorAll('[data-product-section]').forEach(initProduct);
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('click', event => {
    const menu = event.target.closest('.mobile-menu');
    if (menu && event.target.closest('a')) menu.open = false;
    document.querySelectorAll('.nav-dropdown[open],.mobile-menu[open]').forEach(el => {
      if (!el.contains(event.target)) el.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nav-dropdown[open],.mobile-menu[open]').forEach(el => { el.open = false; el.querySelector('summary').focus(); });
  });
})();
